import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1158.513 -0.0123680261L1158.513 123.667893 1709.01384 123.667893 123.680261 1708.87779 123.680261 1158.50063 0 1158.50063 0 1920 761.499365 1920 761.499365 1796.31974 211.122205 1796.31974 1796.33211 211.109837 1796.33211 761.610678 1920.01237 761.610678 1920.01237 -0.0123680261z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFullScreenLine = /*#__PURE__*/function (_Component) {
  _inherits(IconFullScreenLine, _Component);

  var _super = _createSuper(IconFullScreenLine);

  function IconFullScreenLine() {
    _classCallCheck(this, IconFullScreenLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconFullScreenLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFullScreen",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFullScreenLine.displayName = "IconFullScreenLine";
  return IconFullScreenLine;
}(Component);

IconFullScreenLine.glyphName = 'full-screen';
IconFullScreenLine.variant = 'Line';
IconFullScreenLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFullScreenLine;
export { IconFullScreenLine };